/* A path on this app. Absolute URLs and protocol-relative paths stay on the fallback. */

export function inAppPath(value, fallback = "/workspace") {
  if (typeof value !== "string") return fallback;
  if (value.length > 512 || value !== value.trim() || !value.startsWith("/") || value.startsWith("//")) {
    return fallback;
  }
  if (value.includes("://") || /[\u0000-\u001f\\@]/.test(value)) return fallback;
  let decoded = value;
  try {
    decoded = decodeURIComponent(value);
  } catch {
    return fallback;
  }
  if (!decoded.startsWith("/") || decoded.startsWith("//") || decoded.includes("://")) return fallback;
  if (/[\u0000-\u001f\\@]/.test(decoded)) return fallback;
  return value;
}
